import type { IncidenceQueryData } from 'modules/bookkeepers/hooks/useGetIncidences'

import { MESSAGE_SENDER } from 'modules/bookkeepers/lib/constants'

const incidenceHasMessage = (isBookkeeper: boolean, incidence?: IncidenceQueryData | null) => {
  return (
    (incidence?.hasMessage &&
      (isBookkeeper
        ? incidence.messageFrom === MESSAGE_SENDER.admin
        : incidence.messageFrom === MESSAGE_SENDER.bookkeeper)) ??
    false
  )
}

export default incidenceHasMessage
